import cl from 'classnames'
import Link from 'next/link'
import Image from 'next/image'

import { ArticlePreview } from '@components/article-preview'
import { HeaderSection } from '@components/header-section'
import { Author } from '@services/api/authors'
import { Highlight } from 'types/highlight'
import { ArticleWriter } from './article-writer'

import styles from './styles.module.scss'

interface Props {
  highlights: Highlight[]
  authors: Author[]
  className?: string
}

export const Opinion: React.FC<Props> = ({
  highlights = [],
  authors = [],
  className
}) => {
  const [first, second, thirth, fourth, fifth, sixth, seventh, eigth] =
    highlights

  const sponsor = fifth?.sponsor

  return (
    <div className={cl(className, 'flex flex-col gap-y-6')}>
      <div className={styles.container}>
        <div
          className={cl(
            styles.main,
            `${sponsor ? 'col-span-12 lg:col-span-8' : 'col-span-12'}  `
          )}
        >
          <div>
            <HeaderSection
              onPress="Veja todos os artigos de opinião"
              sendTo="/noticias/editoria/opiniao"
            >
              <h2>Opinião</h2>
            </HeaderSection>
            <div className={styles.articles}>
              {Array.from([first, second, thirth, fourth]).map(highlight => (
                <ArticlePreview
                  articlePath={highlight?.path}
                  key={highlight?.id}
                  editorial={highlight?.authors[0]?.name}
                  editorialPath={highlight?.authors[0]?.path}
                  imageUrl={highlight?.thumbnailImage?.path}
                  title={highlight?.title}
                  direction="right"
                  readingTime={`${highlight?.timeToRead} min de leitura`}
                  videoUrl={highlight?.videoUrl}
                  articleType={highlight?.articleType}
                />
              ))}
            </div>
          </div>
          <ArticleWriter authors={authors.slice(0, 4)} />
        </div>
        {sponsor && (
          <div className={styles.aside}>
            <div className={styles.header}>
              <span>Conteúdo Patrocinado oferecido por:</span>
              <div className="w-full h-20 flex items-end justify-end">
                {sponsor && sponsor.imageUrl && (
                  <Image
                    className="object-contain"
                    width={80}
                    height={80}
                    src={sponsor.imageUrl}
                    alt="sponsor"
                    loading="lazy"
                  />
                )}
              </div>
            </div>
            <div className="flex flex-col gap-y-4 mt-8">
              {Array.from([fifth, sixth, seventh]).map(highlight => (
                <ArticlePreview
                  articlePath={highlight?.path}
                  key={highlight?.id}
                  editorial={sponsor?.name}
                  title={highlight?.title}
                  badge
                  readingTime={
                    highlight && `${highlight?.timeToRead} min de leitura`
                  }
                  videoUrl={highlight?.videoUrl}
                  articleType={highlight?.articleType}
                />
              ))}

              {sponsor && (
                <Link
                  href={`/noticias/hub/${sponsor?.slug}`}
                  className={styles.link}
                >
                  Veja todos os conteúdos do hub
                </Link>
              )}

              {eigth && (
                <ArticlePreview
                  articlePath={eigth.path}
                  imageUrl={eigth.thumbnailImage.path}
                  title={eigth.title}
                  description={eigth.shortContent}
                  direction="left"
                  readingTime={eigth && `${eigth.timeToRead} min de vídeo`}
                  videoUrl={eigth?.videoUrl}
                  articleType={eigth?.articleType}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
